import { DataBean } from "../../DataBean";


export class SexType extends DataBean {

    public async getSexTypeList(args: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getSexTypeList_Number", [args]);
    }

}